module.exports = __webpack_public_path__ + "img/razzo-head-page-4.1974ee8b.webp";